import styled from 'styled-components';
import { DESKTOP_WIDTH, TABLET_WIDTH, MOBILE_WIDTH, ANIMATION_SPEED } from '../../globalUtils';
import { ReactComponent as ShieldSVG } from '../../../icons/Shield.svg';
import { ReactComponent as LightBulbSVG } from '../../../icons/LightBulb.svg';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TopText = styled.div`
    color: #003a70;
    text-align: center;
    font-size: 18px;
    width: 1016px;
    margin-bottom: 101px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 16px;
        width: 707px;
        margin-bottom: 49px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 315px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 14px;
        width: 280px;
    }
`;

export const WhiteArea = styled.div`
    display: flex;
    flex-direction: row;
    height: 427px;
    background-color: #ffffff;
    border-radius: 100px 40px 0 0;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        flex-direction: column;
        height: 807px;
        width: 100%;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 648px;
    }
`;

export const InsuranceTypes = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 616px;
    border-left: 1px solid #e9ecf1;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: 100%;
        border-left: 0px;
        border-bottom: 3px solid #e9ecf1;
        height: 439px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 264px;
    }
`;

export const Shield = styled(ShieldSVG)`
    height: 53px;
    width: 45px;
    margin-top: 32px;
    
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 42px;
        width: 36px;
        margin: 50px 0 22px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 27px;
        width: 23px;
        margin: 26px 0 9px;
    }
`;

export const TypesText = styled.div`
    color: #ff4438;
    font-size: 26px;
    font-weight: 600;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 20px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 18px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 16px;
    }
`;

export const Types = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 59px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        margin-top: 66px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        margin-top: 20px;
    }
`;

export const Type = styled.div`
    display: flex;
    flex-wrap: wrap;
    height: 72px;
    width: 176px;
    border-radius: 6px;
    background-color: ${({ current }) => current ? '#ff4438' : '#003a70'};
    border: 1px solid ${({ current }) => current ? '#ff4438' : '#003a70'};
    color: #ffffff;
    box-shadow: ${({ current }) => current ? '0 2px 4px 0px rgba(0, 0, 0, 0.5)' : 'none'};
    font-size: 17px;
    margin: 5px;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    transition: ${ANIMATION_SPEED}ms all ease-in-out;

    :hover {
        text-decoration: ${({ current }) => current ? 'none' : 'underline'};
        border-color: #ff4438;
    }

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        height: 59px;
        width: 91px;
        border-radius: 3px;
        box-shadow: 0 1px 2px 0px rgba(0, 0, 0, 0.5);
        font-size: 14px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        height: 59px;
        width: 80px;
        font-size: 12px;
    }
`;

export const InsuranceInfo = styled.div`
    display: flex;
    flex-direction: column;
    width: 333px;
    padding: 32px 39px 38px 35px;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        width: 100%;
        align-items: center;
        padding: 19px 0 30px;
        flex: 1 0 auto;
    }
`;

export const LightBulb = styled(LightBulbSVG)`
    height: 49px;
    width: 30px;
    opacity: 0.9;
    margin-bottom: 8px;
`;

export const InfoTitle = styled.div`
    color: #ff4438;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 25px;

    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        font-size: 18px;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 16px;
    }
`;

export const InfoText = styled.div`
    color: #003a70;
    font-size: 18px;
    flex: 1 1 auto;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 16px;
    }
    @media only screen and (max-width: ${TABLET_WIDTH}px) {
        width: 285px;
        text-align: center;
    }
    @media only screen and (max-width: ${MOBILE_WIDTH}px) {
        font-size: 14px;
    }
`;

export const InfoCtaText = styled.div`
    font-weight: bold;
    color: #003a70;
    font-size: 18px;
    margin-bottom: 10px;
    align-self: center;
    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        font-size: 14px;
    }
`;

export const InfoCta = styled.div`
    cursor: pointer;
    display: flex;
    height: 59px;
    width: 326px;
    background-color: #ff4438;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.5);
    color: #ffffff;
    justify-content: center;
    align-items: center;
    font-size: 23px;
    font-weight: 600;

    @media only screen and (max-width: ${DESKTOP_WIDTH}px) {
        height: 43px;
        width: 222px;
        font-size: 16px;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0px rgba(0, 0, 0, 0.5);
    }
`;

